import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { title: "", subtitle: "", cta: "SHOP NOW", link: "/shop/all", image: "", position: 1, active: true };

export default function AdminBanners() {
  const [banners, setBanners] = useState([]);
  const [draft, setDraft] = useState(null);

  const load = () => api.get("/admin/banners").then((r) => setBanners(r.data.banners));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/banners", { ...draft, position: Number(draft.position) });
      toast.success("Banner created");
      setDraft(null);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete banner?")) return;
    await api.delete(`/admin/banners/${id}`);
    load();
  };

  return (
    <div className="p-8" data-testid="admin-banners-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-xs text-[#FF3B30] tracking-widest">CMS</div>
          <h1 className="font-display text-5xl tracking-tighter mt-2">BANNERS</h1>
        </div>
        <button onClick={() => setDraft({ ...EMPTY })} className="bg-[#FF3B30] text-white px-6 py-3 font-display tracking-widest text-xs hover:bg-black inline-flex items-center gap-2" data-testid="admin-add-banner">
          <Plus size={14} /> NEW BANNER
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {banners.map((b) => (
          <div key={b.id} className="border border-black/10 bg-white overflow-hidden">
            <div className="relative h-40">
              <img src={b.image} alt="" className="w-full h-full object-cover opacity-60" />
              <div className="absolute inset-0 p-4 flex flex-col justify-end">
                <div className="font-display text-2xl tracking-tighter">{b.title}</div>
                <div className="text-xs text-black/70">{b.subtitle}</div>
              </div>
            </div>
            <div className="p-3 flex justify-between items-center">
              <div className="text-xs font-mono text-black/50">POS {b.position} · {b.cta} → {b.link}</div>
              <button onClick={() => del(b.id)} className="hover:text-[#FF3B30]"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>

      {draft && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-white border border-black/20 w-full max-w-md p-6">
            <h2 className="font-display text-3xl tracking-tighter mb-4">NEW BANNER</h2>
            <div className="space-y-3">
              <Field label="TITLE" value={draft.title} onChange={(v) => setDraft({ ...draft, title: v })} />
              <Field label="SUBTITLE" value={draft.subtitle} onChange={(v) => setDraft({ ...draft, subtitle: v })} />
              <Field label="CTA TEXT" value={draft.cta} onChange={(v) => setDraft({ ...draft, cta: v })} />
              <Field label="LINK URL" value={draft.link} onChange={(v) => setDraft({ ...draft, link: v })} />
              <Field label="IMAGE URL" value={draft.image} onChange={(v) => setDraft({ ...draft, image: v })} />
              <Field label="POSITION" type="number" value={draft.position} onChange={(v) => setDraft({ ...draft, position: v })} />
              <div className="flex gap-3 pt-4">
                <button onClick={save} className="bg-[#FF3B30] text-white px-6 py-3 font-display tracking-widest text-xs">SAVE</button>
                <button onClick={() => setDraft(null)} className="border border-black/30 px-6 py-3 font-display tracking-widest text-xs">CANCEL</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, onChange, type = "text" }) {
  return (
    <label className="block">
      <span className="font-display tracking-widest text-[10px] text-black/50">{label}</span>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} className="w-full bg-transparent border border-black/20 px-3 py-2 mt-1" />
    </label>
  );
}
